<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Demographic Report</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /

      <b>Reports</b> /
      <b>Demographic</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div class="row mb-4">
      <div class="col-lg-12 col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title">
              <button class="btn btn-primary" @click="print">Print</button>
            </div>
            <div id="printGraph">
              <GChart type="PieChart" :data="chart" :options="pieOptions" />

              <GChart
                type="ColumnChart"
                :data="columnData"
                :options="columnOptions"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { GChart } from "vue-google-charts";

export default {
  components: {
    GChart
  },

  data() {
    return {
      columnData: [],
      chart: [],

      columnOptions: {
        title: "User By Age Distribution",
        height: 600,
        legend: "bottom"
      },

      pieOptions: {
        title: "Gender",
        pieHole: 0.5,
        height: 500,
        legend: "bottom"
      }
    };
  },

  methods: {
    //print graph
    print() {
      // Pass the element id here
      this.$htmlToPaper("printGraph");
    },

    done() {
      alert("Done");
    },

    getData() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("/reports/demographic", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.allData = res.data;
            this.columnData = this.allData.Bar_Chart;
            this.chart = this.allData.Donut_Chart;
          });
      }
    }
  },

  mounted() {
    this.getData();
  }
};
</script>
